<div class="background"></div>
<div class="container">
    <div class="signup-box">
        <header class="signup-header">
            <h1>{{ headerText }}</h1>
        </header>
        <p class="content-text">
            {{ contentText }}
        </p>
    </div>
</div>
